import React from 'react';

export const NotAllowed = () => <div>Not allowed on this page</div>;
